/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The AqaCellNote model module.
 * @module model/AqaCellNote
 * @version v0
 */
export default class AqaCellNote {
  /**
   * Constructs a new <code>AqaCellNote</code>.
   * @alias module:model/AqaCellNote
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaCellNote</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaCellNote} obj Optional instance to populate.
   * @return {module:model/AqaCellNote} The populated <code>AqaCellNote</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaCellNote();
      if (data.hasOwnProperty('snapshotId'))
        obj.snapshotId = ApiClient.convertToType(data['snapshotId'], 'String');
      if (data.hasOwnProperty('column'))
        obj.column = ApiClient.convertToType(data['column'], 'Number');
      if (data.hasOwnProperty('row'))
        obj.row = ApiClient.convertToType(data['row'], 'Number');
      if (data.hasOwnProperty('note'))
        obj.note = ApiClient.convertToType(data['note'], 'String');
      if (data.hasOwnProperty('noteEditorId'))
        obj.noteEditorId = ApiClient.convertToType(data['noteEditorId'], 'String');
      if (data.hasOwnProperty('noteDate'))
        obj.noteDate = ApiClient.convertToType(data['noteDate'], 'Number');
      if (data.hasOwnProperty('suggestion'))
        obj.suggestion = ApiClient.convertToType(data['suggestion'], 'String');
      if (data.hasOwnProperty('suggestionEditorId'))
        obj.suggestionEditorId = ApiClient.convertToType(data['suggestionEditorId'], 'String');
      if (data.hasOwnProperty('suggestionDate'))
        obj.suggestionDate = ApiClient.convertToType(data['suggestionDate'], 'Number');
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} snapshotId
 */
AqaCellNote.prototype.snapshotId = undefined;

/**
 * @member {Number} column
 */
AqaCellNote.prototype.column = undefined;

/**
 * @member {Number} row
 */
AqaCellNote.prototype.row = undefined;

/**
 * @member {String} note
 */
AqaCellNote.prototype.note = undefined;

/**
 * @member {String} noteEditorId
 */
AqaCellNote.prototype.noteEditorId = undefined;

/**
 * @member {Number} noteDate
 */
AqaCellNote.prototype.noteDate = undefined;

/**
 * @member {String} suggestion
 */
AqaCellNote.prototype.suggestion = undefined;

/**
 * @member {String} suggestionEditorId
 */
AqaCellNote.prototype.suggestionEditorId = undefined;

/**
 * @member {Number} suggestionDate
 */
AqaCellNote.prototype.suggestionDate = undefined;

/**
 * @member {String} id
 */
AqaCellNote.prototype.id = undefined;

